import React, { useEffect, useState } from "react";
import axios from "axios";
import { TablaCompleta } from "../tablas/tabla_simple";
import moment from "moment";
import { HeadersAuth } from "../funciones_utiles";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { manejarError } from "../manejo_errores";
import { FaRegEdit, FaRegTrashAlt, FaEye } from "react-icons/fa";
import { Modal, Row, Col, Image, Button } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";

export const PreInscriptos = ({ sesion, setAlerta }) => {
  const manejarAlertas = (tipo, mensaje) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  const MySwal = withReactContent(Swal);
  const [refresh, setRefresh] = useState("");
  const [datos, setDatos] = useState([]);
  const [modalPreinscriptoVisible, setModalPreinscriptoVisible] = useState(false);
  const [preinscriptoSeleccionado, setPreinscriptoSeleccionado] = useState(null);

  useEffect(() => {
    const fetchDatos = async () => {
      await fetchPreinscriptos(sesion.id_asociacion)
    };
    fetchDatos()
  }, [refresh])

  const fetchPreinscriptos = async (id_asociacion) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_DOMINIO}/pre-inscriptos/${id_asociacion}`);
      setDatos(response.data);
      // console.log("data", response.data)
    } catch (error) {
      manejarAlertas("error", "Error al obtener pre-registros.");
    }
  };

  const handleEliminarPreinscripcion = (id) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    MySwal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(
            `${process.env.REACT_APP_DOMINIO}/pre-inscriptos/${id}`,
            HeadersAuth
          );
          if (response.status === 200) {
            manejarAlertas("success", "El pre-registro ha sido eliminado.");
            setRefresh(Date.now()); // Actualiza la tabla
          }
        } catch (error) {
          manejarAlertas("error", manejarError(error));
        }
      }
    });
  };

  const confirmarInscripcion = async (id) => {
    try {
      const preinscripto = Array.isArray(datos) ? datos.find((p) => p.id === id) : null;

      if (!preinscripto) {
        manejarAlertas("error", "No se encontró el pre-registro.");
        return;
      };

      await axios.post(`${process.env.REACT_APP_DOMINIO}/email-preinscripto/${id}`,
        {
          id_asociacion: preinscripto.asociacion_id
        }
      );

      const response = await axios.post(`${process.env.REACT_APP_DOMINIO}/confirmar-preinscriptos/${id}`,
        {
          id_asociacion: preinscripto.asociacion_id
        }
      );

      if (response.status == 200) {
        manejarAlertas("success", "El pre-registro ha sido confirmado.");
      };
      
      setRefresh(Date.now());
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  }

  const modalPreinscriptos = (id) => {
    const preinscripto = Array.isArray(datos)
      ? datos.find((p) => p.id === id)
      : null;

    if (!preinscripto) {
      manejarAlertas("error", "No se encontró el pre-registro.");
      return;
    }

    setPreinscriptoSeleccionado(preinscripto);
    setModalPreinscriptoVisible(true);
  };

  const elScroll = { x: 0 };
  const columns = [
    {
      title: "DNI",
      key: "dni",
      align: "left",
      width: "100px",
      sorter: (a, b) => a.dni - b.dni,
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {a.dni}
        </div>
      ),
    },
    {
      title: "Piloto",
      key: "nombre",
      align: "left",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>{a.apellido}, {a.nombre}</div>
      ),
    },
    {
      title: "Teléfono",
      key: "numero_telefono",
      align: "left",
      sorter: (a, b) => a.numero_telefono.localeCompare(b.numero_telefono),
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>{a.numero_telefono}</div>
      ),
    },
    {
      title: "Nacimiento",
      key: "fecha_nacimiento",
      align: "left",
      sorter: (a, b) => a.fecha_nacimiento.localeCompare(b.fecha_nacimiento),
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>{moment(`${a.fecha_nacimiento}`, "YYYY-MM-DD").format("DD/MM/YYYY")}</div>
      ),
    },
    {
      title: "Email",
      key: "email",
      align: "left",
      sorter: (a, b) => a.email.localeCompare(b.email),
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>{a.email}</div>
      ),
    },
    {
      title: "Localidad",
      key: "localidad",
      align: "left",
      sorter: (a, b) => a.localidad.localeCompare(b.localidad),
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>{a.localidad}</div>
      ),
    },
    {
      title: "Licencia",
      key: "licencia",
      align: "center",
      render: (_, record) => {
        const tieneLicencia =
          (record.tipo_licencia === "IMAGENES" &&
            record.licencia_frente &&
            record.licencia_dorso) ||
          (record.tipo_licencia === "PDF" &&
            record.licencia_pdf);

        return (
          <div
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: tieneLicencia ? "#16803C" : "#BA1721",
            }}
          >
            {record.tipo_licencia === "PDF"
              ? "PDF"
              : tieneLicencia
              ? "Imágenes"
              : "Sin cargar"}
          </div>
        );
      },
    },
    {
      title: () => (
        <div style={{ textAlign: "center" }}>
          <span></span>
        </div>
      ),
      key: "opciones",
      align: "center",
      render: (_, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          {/* <FaRegEdit
            className="iconos-tablas"
            style={{ color: "blue", cursor: "pointer", marginRight: "10px" }}
            onClick={() => handleEdit(record.id)}
          /> */}
          <FaEye
            title="Ver información"
            className="iconos-tablas"
            style={{ color: "rgb(34, 52, 99)", cursor: "pointer", marginRight: "10px" }}
            onClick={() => modalPreinscriptos(record.id)}
          />
          <FaRegTrashAlt
            className="iconos-tablas"
            style={{ color: "red", cursor: "pointer" }}
            onClick={() => handleEliminarPreinscripcion(record.id)}
          />
        </div>
      ),
    },
  ];

  const getUrlLicenciaPreinscripto = (lado) => {
    if (!preinscriptoSeleccionado) return null;

    const archivo =
      lado === "frente"
        ? preinscriptoSeleccionado.licencia_frente
        : preinscriptoSeleccionado.licencia_dorso;

    if (!archivo) return null;

    return `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${preinscriptoSeleccionado.asociacion_id}/IMAGENES/LICENCIAS_PREINSCRIPTOS/${preinscriptoSeleccionado.dni}/${archivo}`;
  };

  const getUrlLicenciaPdfPreinscripto = () => {
    if (!preinscriptoSeleccionado) return null;

    if (!preinscriptoSeleccionado.licencia_pdf) return null;

    return `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${preinscriptoSeleccionado.asociacion_id}/IMAGENES/LICENCIAS_PREINSCRIPTOS/${preinscriptoSeleccionado.dni}/${preinscriptoSeleccionado.licencia_pdf}`;
  };

  const stylesModal = {
    infoItem: {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      padding: "10px 12px",
      border: "1px solid #eee",
      borderRadius: 8,
      backgroundColor: "#fafafa",
      minHeight: 65,
    },

    licenciaCard: {
      border: "1px solid #eee",
      borderRadius: 8,
      padding: 12,
      backgroundColor: "#fafafa",
    },

    licenciaTitulo: {
      fontWeight: 600,
      marginBottom: 8,
    },

    licenciaImagen: {
      objectFit: "cover",
      borderRadius: 6,
      border: "1px solid #ddd",
    },

    sinLicencia: {
      padding: 14,
      borderRadius: 8,
      backgroundColor: "#fff7e6",
      border: "1px solid #ffd591",
      color: "#ad6800",
      fontWeight: 600,
    },
    pdfCard: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: 30,
      border: "1px solid #eee",
      borderRadius: 8,
      backgroundColor: "#fafafa",
    },
  };


  console.log("URL frente:", getUrlLicenciaPreinscripto("frente"));
console.log("URL dorso:", getUrlLicenciaPreinscripto("dorso"));

  return (
    <>
      <section
        id="seccionPiloto"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1em",
        }}
      >
        <h1 className="titulos">Pre-Registros</h1>
      </section>
      {datos.length > 0 ? (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 50 }}>
          <TablaCompleta 
            tituloPDF={"pre_registros"}
            elScroll={elScroll}
            columns={columns}
            fetchDatos={datos}
            tituloBanner={"Pre-Registros"}
            idAsociacion={sesion.id_asociacion}
          />
        </div>
      ) : (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 30 }}>
          <p>No hay pre-registros disponibles.</p>
        </div>
      )}

      <Modal
        open={modalPreinscriptoVisible}
        onCancel={() => setModalPreinscriptoVisible(false)}
        footer={null}
        centered
        width={800}
        title="Detalle del pre-registro"
      >
        {preinscriptoSeleccionado && (
          <div>
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <div style={stylesModal.infoItem}>
                  <strong>DNI:</strong>
                  <span>{preinscriptoSeleccionado.dni}</span>
                </div>
              </Col>

              <Col xs={24} md={12}>
                <div style={stylesModal.infoItem}>
                  <strong>Nombre:</strong>
                  <span>{preinscriptoSeleccionado.nombre}</span>
                </div>
              </Col>

              <Col xs={24} md={12}>
                <div style={stylesModal.infoItem}>
                  <strong>Apellido:</strong>
                  <span>{preinscriptoSeleccionado.apellido}</span>
                </div>
              </Col>

              <Col xs={24} md={12}>
                <div style={stylesModal.infoItem}>
                  <strong>Email:</strong>
                  <span>{preinscriptoSeleccionado.email}</span>
                </div>
              </Col>

              <Col xs={24} md={12}>
                <div style={stylesModal.infoItem}>
                  <strong>Teléfono:</strong>
                  <span>{preinscriptoSeleccionado.numero_telefono}</span>
                </div>
              </Col>

              <Col xs={24} md={12}>
                <div style={stylesModal.infoItem}>
                  <strong>Localidad:</strong>
                  <span>{preinscriptoSeleccionado.localidad}</span>
                </div>
              </Col>

              <Col xs={24} md={12}>
                <div style={stylesModal.infoItem}>
                  <strong>Fecha de nacimiento:</strong>
                  <span>
                    {moment(
                      `${preinscriptoSeleccionado.fecha_nacimiento}`,
                      "YYYY-MM-DD"
                    ).format("DD/MM/YYYY")}
                  </span>
                </div>
              </Col>
            </Row>

            <hr style={{ margin: "22px 0" }} />

            <h3 style={{ marginBottom: 15 }}>Licencia médica</h3>

            {preinscriptoSeleccionado.tipo_licencia === "IMAGENES" &&
            preinscriptoSeleccionado.licencia_frente &&
            preinscriptoSeleccionado.licencia_dorso ? (

              <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                  <div style={stylesModal.licenciaCard}>
                    <p style={stylesModal.licenciaTitulo}>Frente</p>

                    <Image
                      src={getUrlLicenciaPreinscripto("frente")}
                      alt="Frente licencia médica"
                      width="100%"
                      height={220}
                      style={stylesModal.licenciaImagen}
                    />
                  </div>
                </Col>

                <Col xs={24} md={12}>
                  <div style={stylesModal.licenciaCard}>
                    <p style={stylesModal.licenciaTitulo}>Dorso</p>

                    <Image
                      src={getUrlLicenciaPreinscripto("dorso")}
                      alt="Dorso licencia médica"
                      width="100%"
                      height={220}
                      style={stylesModal.licenciaImagen}
                    />
                  </div>
                </Col>
              </Row>

            ) : preinscriptoSeleccionado.tipo_licencia === "PDF" &&
                preinscriptoSeleccionado.licencia_pdf ? (

              <div style={stylesModal.pdfCard}>
                <FilePdfOutlined
                  style={{
                    fontSize: 60,
                    color: "#BA1721",
                  }}
                />

                <p
                  style={{
                    marginTop: 15,
                    marginBottom: 20,
                    fontWeight: 600,
                  }}
                >
                  Licencia médica en PDF
                </p>

                <Button
                  type="primary"
                  href={getUrlLicenciaPdfPreinscripto()}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundColor: "#233463",
                  }}
                >
                  Ver PDF
                </Button>
              </div>

            ) : (
              <div style={stylesModal.sinLicencia}>
                Este pre-registro no tiene licencia médica cargada.
              </div>
            )}

            <Row gutter={16} justify="end" style={{ marginTop: 25 }}>
              <Col xs={24} sm={12}>
                <Button
                  style={{
                    width: "100%",
                    backgroundColor: "#233463",
                    color: "#FFF",
                    fontSize: 18,
                    cursor: "pointer",
                  }}
                  onClick={() => setModalPreinscriptoVisible(false)}
                >
                  Cancelar
                </Button>
              </Col>

              <Col xs={24} sm={12}>
                <Button
                  type="primary"
                  onClick={() => {
                    setModalPreinscriptoVisible(false);
                    confirmarInscripcion(preinscriptoSeleccionado.id);
                  }}
                  style={{
                    width: "100%",
                    backgroundColor: "#BA1721",
                    color: "#FFF",
                    fontSize: 18,
                    cursor: "pointer",
                  }}
                >
                  Confirmar registro
                </Button>
              </Col>
            </Row>
          </div>
        )}
      </Modal>
    </>
  );
}